module.exports = __webpack_public_path__ + "img/invoice_list.4c20ee75.svg";